export default __webpack_public_path__ + "static/media/multi-language-UK.9e719d27.svg";